import React, {useState} from "react";
import _ from "lodash"
import {Selector} from "../../../components";
import { UncontrolledTooltip } from "reactstrap";
import './style.scss'
import {sanitizeQuerySelector} from "./util";


function TemplateSection({
                           sectionObj, copyFunction, deleteFunction,
                           sectionIndex, sectionUpdated,
                         }) {
  const [fields, setFields] = useState(_.cloneDeep(sectionObj.fields))
  const [notes, setNotes] = useState(_.cloneDeep(sectionObj.notes))
  const [sectionDisplayName, setSectionDisplayName] = useState(_.clone(sectionObj.sectionDisplayName))
  const [isActive, setIsActive] = useState(sectionObj.active)
  const [required, setIsRequired] = useState(sectionObj.required)
  const [locationObject, setIsLocationObject] = useState(sectionObj.locationObject)
  const [showFieldSelector, setShowFieldSelector] = useState(false)

  const fieldTypes = [
    {type: "TextSingleLine", displayName: "Text"},
    {type: "TextMultiLine", displayName: "Multi Line Text"},
    {type: "Url", displayName: "Url"},
    {type: "ImageUrl", displayName: "Image Url"},
    {type: "DatePicker", displayName: "Date"},
    {type: "HoursSet", displayName: "Hours"},
    {type: "PdfUrl", displayName: "PDF Url"},
    {type: "Integer", displayName: "Integer"},
    {type: "Boolean", displayName: "Boolean"}
  ]

  const updateFieldDisplayName = (event, fieldIndex) => {
    sectionObj.fields[fieldIndex].fieldDisplayName = event.target.value
    setFields(_.cloneDeep(sectionObj.fields))
    sectionUpdated(sectionObj, sectionIndex)
  }

  const updateSectionDisplayName = (event) => {
    sectionObj.sectionDisplayName = event.target.value
    setSectionDisplayName(event.target.value)
    sectionUpdated(sectionObj, sectionIndex)
  }

  const updateNotes = (event) => {
    sectionObj.notes = event.target.value
    setNotes(event.target.value)
    sectionUpdated(sectionObj, sectionIndex)
  }

  const removeField = (index) => {
    sectionObj.fields.splice(index, 1)
    sectionObj.fields = [...sectionObj.fields]
    setFields(sectionObj.fields)
    sectionUpdated(sectionObj, sectionIndex)
  }

  const toggleActive = () => {
    const newState = !isActive
    sectionObj.active = newState
    setIsActive(newState)
    sectionUpdated(sectionObj, sectionIndex)
  }

  const toggleRequired = () => {
    const newState = !required
    sectionObj.required = newState
    setIsRequired(newState)
    sectionUpdated(sectionObj, sectionIndex)
  }
  //TODO - seems odd to track state on the model and duplicate in the component
  const toggleLocationObject = () => {
    const newState = !locationObject
    sectionObj.locationObject = newState
    setIsLocationObject(newState)
    sectionUpdated(sectionObj, sectionIndex)
  }

  const copyMe = () => {
    copyFunction(sectionObj)
  }

  const deleteMe = () => {
    deleteFunction(sectionIndex)
  }

  const fieldTypeSelected = (selected) => {
    var field = {
      fieldType: selected.type,
      fieldDisplayName: "Enter a name for " + selected.displayName,
      fieldId: undefined
    }
    fields.push(field)
    const newFields = _.cloneDeep(fields)
    sectionObj.fields = newFields
    setFields(newFields)
    setShowFieldSelector(false)
    sectionUpdated(sectionObj, sectionIndex)
  }


  return (
    <div className="row p-2 mb-4 border-bottom">
      <div className="col-4">
        <div className="row"><input className="form-control text-input" key={"sectionDisplayName-input" + sectionIndex}
                                    value={sectionDisplayName} onChange={e => updateSectionDisplayName(e)}/></div>
        {fields.map((field, index) => {
          // Id for the tooltip, either gets the field id or makes a new one for newly added fields
          // Need to sanitize the selector here or the frontend will crash. Remove '?'s from target
          const targetId = sanitizeQuerySelector(field?.fieldId ? field?.fieldId : `${field.fieldType}-${index}`)

          return <div key={"row1" + index} className="row">
            <UncontrolledTooltip 
              arrowClassName="field-tooltip-arrow"  
              placement="top-start" 
              target={targetId} 
            >
              {/* Get the pretty display field type name */}
              {fieldTypes.find(x => { return x.type === field.fieldType })?.displayName}
            </UncontrolledTooltip>
            <input 
              id={targetId} 
              className="form-control text-input col-11 mt-2" 
              key={field.fieldId} 
              value={field.fieldDisplayName}
              onChange={e => updateFieldDisplayName(e, index)}
            />
            <button type="button" className="btn btn-primary mt-2" onClick={event => removeField(index)}>
              <i className="fa fa-minus"/>
            </button>
          </div>
        })}
        <button type="button" className="btn btn-secondary ml-n2 mt-2" onClick={e => setShowFieldSelector(true)}>
          <i className="fa fa-plus"/>
        </button>
        {showFieldSelector && <Selector
          options={fieldTypes}
          getKey={x => x.type}
          onSelected={selected => fieldTypeSelected(selected)}
          renderOption={x => <span>{x.displayName}</span>}
        />}
      </div>
      <div className="col-4">
        <textarea className="form-control text-area" key={"notes-key" + sectionIndex} value={notes} type="text"
                  onChange={e => updateNotes(e)}/>
      </div>
      <div className="col-1">
        <input key={"active-toggle-off" + sectionIndex} type="checkbox" checked={isActive}
               onChange={e => toggleActive()}/>
      </div>
      <div className="col-1">
        <input key={"required-checkbox" + sectionIndex} type="checkbox" checked={required}
               onChange={e => toggleRequired()}/>
      </div>
      <div className="col-1">
        <input key={"location-checkbox" + sectionIndex} type="checkbox" checked={locationObject}
               onChange={e => toggleLocationObject()}/>
      </div>
      <div className="col-1">
        <span key={"copy-icon" + sectionIndex} className="fa fa-clone" onClick={e => copyMe()}/>
      </div>
      <div className="col-1">
        {sectionObj.custom &&
        <span key={"delete-icon" + sectionIndex} className="fas fa-trash-alt" onClick={e => deleteMe()}/>}
      </div>
    </div>
  )
}

export default TemplateSection
